const { labelizedEmployerProfileTags } = require('buyside/util/constantsFromRails.json');

const filterFormatFundTags = tagNumber => {
  const tagLabel = labelizedEmployerProfileTags.find(
    tag => String(tag.value) === String(tagNumber)
  );
  if (tagLabel) {
    return tagLabel.label;
  } else {
    return 'n/a';
  }
};

export default filterFormatFundTags;
